// src/context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { register, login, getProfileInfo } from 'api/auth/index';
import { setUserId } from "utils/analytics";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem('authToken'))
  const navigate = useNavigate();

  // Save token and tenant id in local storage
  const saveTokenData = (responseData) => {
    const authToken = responseData?.token || null;
    const tenantId = responseData?.tenantId || null;
    // Set Tokens in Local Storage
    localStorage.setItem("authToken", authToken);
    localStorage.setItem("tenantId", tenantId);
    // Save token state
    setToken(authToken);
  }

  // Save Google OAuth data without triggering getUserInfo
  const saveGoogleAuthData = (responseData) => {
    const authToken = responseData?.token || null;
    const tenantId = responseData?.tenantId || null;
    const userData = responseData?.user || responseData;
    
    // Set Tokens in Local Storage
    localStorage.setItem("authToken", authToken);
    localStorage.setItem("tenantId", tenantId);
    
    // Save token and user state directly
    setToken(authToken);
    setUser(userData);
  }

  // Check for validation on token change.
  useEffect(() => {
    if (token) {
      getUserInfo();
    }
  }, [token]);


  // Get the current loggedin user info
  const getUserInfo = async () => {
    try {
      const response = await getProfileInfo();
      const profileData = response.data;

      // Check if registration failed
      if (response?.statusCode !== "10000" || !profileData) {
        return console.log(`Error:`, response?.message || "Token expired");
      }
      // Set user data
      setUser(profileData);

      // Set the user ID in Analytics
      setUserId(profileData._id);
    } catch (err) {
      console.error(err);
      logout();
    }
  }

  // User login handler
  const loginUser = async (data) => {
    const response = await login(data);
    const responseData = response?.data;

    // Check if registration failed
    if (response?.statusCode !== "10000" || !responseData) {
      return console.log("Login failed ");
    }

    saveTokenData(responseData);
    setUser(responseData);

    // Redirect to chat
    navigate('/chat');
  };

  // ! Register will be deprecated in future versions
  const registerUser = async (payload) => {

    // const response = await register(payload);

    // Dummy Data
    const response = {
      status: true,
      status_code: 200,
      data: {
        "refreshToken": "2eKvyfA4CZvnszwywW6-_iLNe5uejfpsEdoFnpO5Cu1MUCI9ADtPhg",
        "registration": {
          "applicationId": "9593779d-53c7-4f52-a1bd-ebbbbe5f142e",
          "data": {},
          "id": "04e10948-35e2-42ec-b18c-3bbd6ab7ab06",
          "insertInstant": 1727158745719,
          "lastLoginInstant": 1727158745719,
          "lastUpdateInstant": 1727158745719,
          "preferredLanguages": [],
          "roles": [],
          "tokens": {},
          "usernameStatus": "ACTIVE",
          "verified": true,
          "verifiedInstant": 1727158745719
        },
        "token": "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IjQzY1NWcnc2a1g2d2c2em5nSk1vMThDczBaYyJ9.eyJleHAiOjE3NDY4NTQ5MDYsImlhdCI6MTc0Njc2ODUwNiwiaXNzIjoiNDMuMjA1LjE1OS4yMzo5MDExIiwic3ViIjoiMmVlMmIwYTctMWMzOC00YTgyLWI2ZmYtNzQ1N2E1MjJlMWUxIiwianRpIjoiYzhlNzkwZmMtNmNmYy00MDdhLThjYmItYjczN2NjODViMzNkIiwiYXV0aGVudGljYXRpb25UeXBlIjoiUEFTU1dPUkQiLCJlbWFpbCI6InZhc2ltcmFqYUBjb2Rld2F2ZS5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwicHJlZmVycmVkX3VzZXJuYW1lIjoidmFzaW0iLCJhdXRoX3RpbWUiOjE3NDY3Njg1MDYsInRpZCI6ImExNjdiNjU2LWIxNzktNDc5OS1hNjdhLTM3NTEzNjg0MGZkOCJ9.Io3O32f4_IaUXE-bq6IzknHf4nSJEgW4cmps9yyohlRKNSvEWdX9W8LK4mpFsjRkMA3j7CMnZruRdZaHsYk7sWiZmnS_UymYNv35nUFqLfXeA01eRlk7RyL_vLXJ9DWy-ANwgxUw2Li-tvsp2_Rw_Oq9ay9p7cx4I66R_jShVkzAttgxLT7k8ywo5Uxapx8KlvQDYEI4Ve3hQoUkILfXs1SOUH0efOVkYS26YBf_Y4R9l4VCu16kxOh7TVjzHtIyxTGBYcJSsteZzVGP7_gF4Oa5sFg_YLZ6Esj9HonAVtCjMn9Lnwj0Res52P_wr0Nu_UPzfTC2HLH1X7ZrZFhJbg",
        "tokenExpirationInstant": 1727162345721,
        "user": {
          "active": true,
          "connectorId": "e3306678-a53a-4964-9040-1c96f36dda72", 
          "data": {},
          "email": "bhaskeranand+test@codewave.com",
          "fullName": "Bhasker Anand Jeenwal",
          "id": "fd1eef13-4689-4658-93e3-f73612236712",
          "insertInstant": 1727158745703,
          "lastLoginInstant": 1727158745719,
          "lastUpdateInstant": 1727158745703,
          "memberships": [],
          "passwordChangeRequired": false,
          "passwordLastUpdateInstant": 1727158745712,
          "preferredLanguages": [],
          "registrations": [],
          "tenantId": "3eb4de4b-b3bb-47b2-a379-bd2d83778d7b",
          "twoFactor": {
            "methods": [],
            "recoveryCodes": []
          },
          "usernameStatus": "ACTIVE",
          "verified": true,
          "verifiedInstant": 1727158745703
        }
      }
    }

    // Check if registration failed
    if (!response?.status || response?.status_code >= 400) {
      return console.log("Registration failed ")
    }

    // Set User data
    setUser(response);
  };

  // Remove the local data & reset states on logout, then redirect to login
  const logout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("tenantId");
    sessionStorage.removeItem("googleCallbackProcessed");
    setUser(null);
    setToken(null);
    navigate("/");
  };

  return (
    <AuthContext.Provider value={{ token, user, login: loginUser, registerUser, logout, saveGoogleAuthData }}>
      {children}
    </AuthContext.Provider>
  );
};